var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0622 4.48604C23.6968 4.48604 17.953 3.01296 15.9056 0.283782C15.6333 -0.047867 15.1437 -0.0957032 14.812 0.176665C14.7729 0.208709 14.737 0.244643 14.7049 0.283782C12.6574 3.01273 6.91358 4.48604 2.54835 4.48604C2.13385 4.48604 1.79785 4.82204 1.79785 5.23654V14.9917C1.79785 23.2433 8.96344 28.2178 15.0993 29.9706C15.2339 30.0097 15.3767 30.0097 15.5113 29.9706C21.6471 28.2178 28.8127 23.2433 28.8127 14.9917V5.23654C28.8127 4.82204 28.4767 4.48604 28.0622 4.48604ZM27.3117 14.9917C27.3117 22.317 20.8923 26.8077 15.3053 28.4684C9.71829 26.8077 3.29863 22.317 3.29863 14.9917V5.97377C7.63615 5.82706 12.7654 4.42882 15.3053 1.87428C17.8454 4.42882 22.9744 5.82706 27.3119 5.97354V14.9917H27.3117Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3037 11.9901V13.4908H11.5532C11.1387 13.4908 10.8027 13.8268 10.8027 14.2413V20.2444C10.8027 20.659 11.1387 20.9949 11.5532 20.9949H19.0573C19.4718 20.9949 19.8078 20.659 19.8078 20.2444V14.2413C19.8078 13.8268 19.4718 13.4908 19.0573 13.4908H18.3068V11.9901C18.3068 10.3323 16.9631 8.98853 15.3053 8.98853C13.6475 8.98853 12.3037 10.3323 12.3037 11.9901ZM18.3068 19.4942H12.3037V14.9916H18.3068V19.4942ZM16.8061 11.9901V13.4908H13.8045V11.9901C13.8045 11.1613 14.4763 10.4893 15.3053 10.4893C16.1341 10.4893 16.8061 11.1613 16.8061 11.9901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyShield);
export default __webpack_public_path__ + "static/media/safety-shield.8f935b15afff1d583f5da5cb4c57933d.svg";
export { ForwardRef as ReactComponent };